export const STATUS_STYLES = {
  active: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", label: "Active" },
  pending: { bg: "bg-blue-50", text: "text-blue-800", border: "border-blue-200", label: "Pending" },
  overdue: { bg: "bg-red-50", text: "text-red-800", border: "border-red-200", label: "Overdue" },
  in_progress: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "In progress" },
  closed: { bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200", label: "Closed" },
  escalated: { bg: "bg-purple-50", text: "text-purple-800", border: "border-purple-200", label: "Escalated" },
  scheduled: { bg: "bg-blue-50", text: "text-blue-800", border: "border-blue-200", label: "Scheduled" },
  completed: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", label: "Completed" },
  open: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Open" },
  under_investigation: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Investigating" },
  draft: { bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200", label: "Draft" },
  published: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", label: "Published" },
  minor: { bg: "bg-blue-50", text: "text-blue-800", border: "border-blue-200", label: "Minor" },
  serious: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Serious" },
  critical: { bg: "bg-red-50", text: "text-red-800", border: "border-red-200", label: "Critical" },
  low: { bg: "bg-blue-50", text: "text-blue-800", border: "border-blue-200", label: "Low" },
  medium: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Medium" },
  high: { bg: "bg-red-50", text: "text-red-800", border: "border-red-200", label: "High" },
};

export default function StatusBadge({ status, label }) {
  const key = (status || "").toLowerCase();
  const s = STATUS_STYLES[key] || { bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200", label: status };
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${s.bg} ${s.text} ${s.border}`}
    >
      {label || s.label}
    </span>
  );
}
